module.exports = __webpack_public_path__ + "static/media/wa-background.2675a051.png";